import request from '@/utils/request';
/**获取架构列表数据 */
export function applicationList(data) {
  return request.post('admin/application/list', data);
}
/**图片上传 */
export const uploadFile = process.env.VUE_APP_BASE_API + 'upload/file';
/**新增应用 */
export function addApplication(data) {
  return request.post('admin/application/store', data);
}
/**更新应用 */
export function editApplication(data) {
  return request.post('admin/application/edit', data);
}
/**更新应用 */
export function deleteApplication(data) {
  return request.post('admin/application/delete', data);
}
export function applicationResource(data) {
  return request.post('admin/application/resource', data);
}
//应用详情
export function applicationInfo(data) {
  return request.post('admin/application/detail', data);
}
export function applicationResource2(data) {
  return request.post('admin/application/getcustomerapply', data);
}
//新增客户-应用分配
export function applicationCustomerList(data) {
  return request.post('admin/application/application-list', data);
}